import create from 'zustand'

export const useHotspotStore = create(() => ({
  ready: false,
  activeHotspots: {},
  readyHotspots: {},
  nearestHotspot: null,
  hoveredHotspot: null,
}))
